'use strict'

exports.codes = {
  ERR_MISSING_SIGNATURE: 'ERR_MISSING_SIGNATURE',
  ERR_INVALID_SIGNATURE: 'ERR_INVALID_SIGNATURE'
}
